<template>
  <fy-form :model="sms_param" :rules="rules" class="fy-form-login-pc" ref="form_sms" v-if="!isInit">
    <div class="wrap1920" id="indexContent">
      <div class="wrap">
        <div class="tourism_main">
          <login-logo></login-logo>
          <div class="logonRight">
            <p>
              <img src="@/assets/images/html/logon01.jpg">
            </p>
            <p class="sms-code">
              <em></em>
              <fy-form-item :inner_width="'100%'" :prop="fields.username.field_enname">
                <fy-input
                  :placeholder="fields.username.field_placeholder"
                  type="text"
                  v-model.trim="sms_param.username"
                ></fy-input>
              </fy-form-item>
              <input
                @click="sendCode"
                class="submitBtn"
                id="send_code"
                name="code"
                type="button"
                value="发送验证码"
              >
            </p>
            <p class="e_mail" style="margin-top: 19px;">
              <em></em>
              <fy-form-item :inner_width="'100%'" :prop="fields.code.field_enname">
                <fy-input
                  :placeholder="fields.code.field_placeholder"
                  type="text"
                  v-model.trim="sms_param.code"
                ></fy-input>
              </fy-form-item>
            </p>
            <a @click="sms_Login()" class="submitBtn" href="javascript:void(0);">登陆</a>
          </div>
          <div class="clear"></div>
        </div>
      </div>
    </div>
  </fy-form>
</template>
<script>
import { LoginLogo } from '@/pages/components'
import { login } from '@/api/base'
import smsCode from '@/api/smsCode'
export default {
  name: 'SmsLogin',
  componentName: 'SmsLogin',
  components: {
    LoginLogo
  },
  data () {
    return {
      isShow: false,
      send_code_url: 'sms_check_code/send_quick_login_sms_check_code/',
      phone: '',
      password: '',
      hostname1: window.location.hostname
        ? window.location.hostname
        : this.$sessionStorageUtil.get('domain_name'),
      // domain:document.domain? document.domain : sessionStorage.getItem('domain_name'),
      form_info: {
        username: '13265582020',
        passwd: '123456'
      },
      sms_param: {
        code: '',
        username: '',
      },
      isInit: true, //判断页面初始化时的异步加载是否完成（由于父子组件间异步传数据，有可能子组件mounted阶段时异步加载还未完成）
      fields: {},
      rules: {}
    }
  },
  created () {
    this.$pageField.init(this, 'fields', 'login').then(res => {
      this.isInit = false //异步加载完成后设置为true
    })
  },
  methods: {
    sms_Login () {
      this.$refs.form_sms.validate((valid, invalidFields) => {
        if (valid) {
          var loading = this.$loadingIndicator.eleOpen('信息审核中...')
          const Qs = require('qs')
          var url = 'oauth/token'
          let obj = {
            mobile: this.sms_param.username,
            verification_code: this.sms_param.code,
            grant_type: 'sms'
          }
          if (this.$sessionStorageUtil.get('weixin_public_no')) {
            obj.open_id = this.$sessionStorageUtil.get('open_id')
          }
          var param = Qs.stringify(obj)
          login(url, param)
            .then(res => {
              this.$sessionStorageUtil.set('next_message', '登陆成功', 60 * 5)
              this.loginAfterPush(loading)
            })
            .catch(err => {
              loading.close()
              this.$msg('请求出错:[' + err.status + ']' + err.get_token_error, 'error')
            })
        } else {
          this.$msg(invalidFields[0].message, 'error')
        }
      })
    },
    sendCode (event) {
      const el = event.currentTarget
      this.$refs.form_sms.validateField('username', (message, invalidFields) => {
        if (message) {
          this.$msg(message, 'error')
        } else {
          let param = smsCode.butResendCountdown(el)
          this.$myPost(this.send_code_url + this.sms_param.username)
            .then(res => {
              const rcode = res.response.data.rcode
              if (rcode == 0) {
                this.$msg('短信验证码发送成功', 'info', 1000);
              } else {
                smsCode.butReset(el, param)
                this.$msg(res.response.data.messages[0].msg, 'info', 1000);
              }
            })
            .catch(err => {
              smsCode.butReset(el, param)
              this.$msg('[' + err.status + ']' + err.message, 'error')
            })
        }
      })
    },
    register () {
      this.$router.push({
        path: 'Regist'
      })
    },
    /**
     * 登陆后的跳转（处理了登陆拦截后的回跳）
     */
    loginAfterPush (loading) {
      //1.router.currentRoute:当前的路由信息对象，我们可以通过router.currentRoute.fullPath获得解析后的 URL，包含查询参数和 hash 的完整路径，
      //如果要访问的页面的路由有命名（name）的话，可以通过router.currentRoute.name获得当前路由的名称。
      const currentRoute = this.$router.currentRoute
      //判断是否时登陆拦截过来的，时则跳回上一个页面，不是则调到首页
      //currentRoute.query.original_hostname == location.hostname    是否加域名判断??
      if (
        currentRoute.query.to_fullPath &&
        currentRoute.query.to_path != currentRoute.path
      ) {
        this.$router.push({
          path: currentRoute.query.to_fullPath
        })
        loading.close()
      } else {
        this.$router.push({
          name: 'memberInfo'
        })
        loading.close()
      }
    },
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/user/smsLogin.vue